<template>
  <div>
    <div class="newslatter" v-if="null ">
      <h3>RECEBA PROMOÇÕES NO SEU EMAIL</h3>
      <div class="ui input">
        <input type="text" placeholder="Seu e-mail..">
        <button class="ui button">Cadastrar</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {};
</script>
